import { useLayoutEffect, useRef, useState } from "react";

//STYLE
import { ContainerSegmented } from "./style";

//PROPS
interface Props {
    opcoes: { descricao: string, disabled?: boolean, disabledMsg?: string }[];
    selecionado: string;
    onChange: (descricao: string) => void;
    disableAll?: boolean;
}

export const Segmented: React.FC<Props> = ({ opcoes, selecionado, onChange, disableAll }) => {

    //REFs
    const refContainer = useRef<HTMLDivElement>(null);

    //STATES
    const [posicao_highlight, setPosicao_highlight] = useState<{ left: number, width: number }>({ left: 0, width: 0 });

    const index_selecionado = (opcoes ?? []).findIndex(item => item.descricao === selecionado);

    useLayoutEffect(() => {
        const container = refContainer.current;
        if (!container || index_selecionado < 0) return;

        const botao = container.querySelectorAll('button')?.[index_selecionado] as HTMLButtonElement;
        if (!botao) return;

        setPosicao_highlight({ left: botao.offsetLeft, width: botao.offsetWidth });
    }, [index_selecionado, opcoes]);

    return (
        <ContainerSegmented ref={refContainer}>
            {(opcoes ?? []).map(({ descricao, disabled, disabledMsg }) => {
                const is_ativo = selecionado === descricao;
                return (
                    <button
                        key={descricao}
                        type="button"
                        className="ContainerSegmented__item"
                        data-active={is_ativo}
                        disabled={disableAll || disabled}
                        title={(disableAll || disabled) ? disabledMsg : descricao}
                        onClick={() => onChange(descricao)}
                    >
                        {descricao}
                    </button>
                )
            })}

            <div
                className="ContainerSegmented__highlight"
                style={{
                    left: posicao_highlight.left,
                    width: posicao_highlight.width,
                    opacity: index_selecionado < 0 ? 0 : 1,
                    transition: 'left 0.25s ease, width 0.25s ease, opacity 0.2s'
                }}
            />
        </ContainerSegmented>
    )
};
